import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import * as ObserverPolyfill from 'resize-observer-polyfill';

var ResizeObserverPolyfill = /*#__PURE__*/function () {
  function ResizeObserverPolyfill(callback) {
    _classCallCheck(this, ResizeObserverPolyfill);
    // Check if ResizeObserver is available in the current browser environment
    if (typeof jest === 'undefined' && !('ResizeObserver' in window)) {
      window.ResizeObserver = ObserverPolyfill.default;
    }
    this.resizeObserver = new window.ResizeObserver(callback);
  }
  return _createClass(ResizeObserverPolyfill, [{
    key: "observe",
    value: function observe(target) {
      return this.resizeObserver.observe(target);
    }
  }, {
    key: "unobserve",
    value: function unobserve(target) {
      this.resizeObserver.unobserve(target);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.resizeObserver.disconnect();
    }
  }]);
}();

export { ResizeObserverPolyfill };
//# sourceMappingURL=polyfills.js.map
